import PropTypes from 'prop-types';
import React, { Component } from "react";

import { AkNavigationItemGroup, AkNavigationItem } from "@atlaskit/navigation";

// import PreferencesIcon from '@atlaskit/icon/glyph/preferences';
import BitbucketOutputIcon from '@atlaskit/icon/glyph/bitbucket/output';

const createItems = [
  {
    title: null,
    items: [
      // ['/account', 'Account Settings', 'Account Settings', PreferencesIcon],
      ['/logout', 'Logout', 'Logout', BitbucketOutputIcon],
    ],
  },
];

export default class AccountDrawer extends Component {
  static propTypes = {
    onItemClicked: PropTypes.func,
  };

  render() {
    return (
      <div>
        {
          createItems.map(itemGroup => {
            return (
              <AkNavigationItemGroup key={itemGroup.title} title={itemGroup.title}>
                {
                  itemGroup.items.map(item => {
                    const [url, text, label, Icon] = item;
                    return (
                      <AkNavigationItem
                        key={url}
                        href={url}
                        icon={<Icon label={label}/>}
                        text={text.valueOf()}
                        onClick={this.props.onItemClicked}
                      />
                    );
                  })
                }
              </AkNavigationItemGroup>
            )
          })
        }
      </div>
    )
  };
}



// WEBPACK FOOTER //
// ./src/components/AccountDrawer.js